import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../atoms/Button';
import Text from '../atoms/Text';
import Badge from '../atoms/Badge';

const ServiceCard = ({
  title,
  subtitle,
  description,
  price,
  duration,
  features = [],
  spots = [],
  image,
  imageUrl, // 新しく追加：画像URLを直接指定
  onBooking,
  onInquire,
  className = ""
}) => {
  const { t } = useTranslation();
  // 画像URLの処理
  const finalImageUrl = imageUrl || image || "";  // 外部から指定された画像URLを使用

  return (
    <div className={`bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 ${className}`}>
      {/* 画像セクション */}
      <div className="relative h-48 md:h-56 overflow-hidden">
        <img
          src={finalImageUrl}
          alt={title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          onError={(e) => {
            // 画像読み込みエラー時のフォールバック
            e.target.src = "";  // 画像のフォールバックは外部から指定
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>

        {/* 価格・期間のオーバーレイ */}
        {(price || duration) && (
          <div className="absolute top-4 right-4 flex flex-col gap-2">
            {duration && (
              <Badge variant="secondary" className="bg-blue-500/90 text-white backdrop-blur-sm">
                {duration}
              </Badge>
            )}
            {price && (
              <Badge variant="primary" className="bg-orange-500/90 text-white backdrop-blur-sm">
                {price}
              </Badge>
            )}
          </div>
        )}
      </div>

      {/* コンテンツセクション */}
      <div className="p-6">
        {subtitle && (
          <Text size="sm" className="text-orange-600 font-medium mb-2">
            {subtitle}
          </Text>
        )}

        <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-3">
          {title}
        </h3>

        <Text className="mb-4 leading-relaxed">
          {description}
        </Text>

        {/* 特徴リスト */}
        {features && features.length > 0 && (
          <div className="mb-4">
            <h4 className="font-semibold text-gray-700 mb-2">{t('common.features')}</h4>
            <ul className="space-y-1">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center text-sm text-gray-600">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mr-3 flex-shrink-0"></div>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* 観光スポットリスト */}
        {spots && spots.length > 0 && (
          <div className="mb-4">
            <h4 className="font-semibold text-gray-700 mb-2">{t('common.visitSpots')}</h4>
            <div className="flex flex-wrap gap-2">
              {spots.map((spot, index) => (
                <Badge key={index} variant="secondary" size="small" className="bg-gray-100 text-gray-700">
                  {spot}
                </Badge>
              ))}
            </div>
          </div>
        )}

        {/* アクションボタン */}
        <div className="flex flex-col sm:flex-row gap-3 mt-6">
          {onBooking && (
            <Button
              size="medium"
              onClick={onBooking}
              className="flex-1"
            >
              {t('common.bookingApply')}
            </Button>
          )}
          {onInquire && (
            <Button
              variant="outline"
              size="medium"
              onClick={onInquire}
              className="flex-1"
            >
              {t('common.inquireDetails')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;